var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled from "styled-components";
import { getColor } from "../../../theme";
import Flex from "../../templates/flex";
import { Text } from "../../typography";
export var ItemContainer = styled(Flex).attrs({
    as: "li",
    role: "option",
    padding: [2, 4],
    alignItems: "center",
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  cursor: pointer;\n  opacity: ", ";\n  pointer-events: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n"], ["\n  cursor: pointer;\n  opacity: ", ";\n  pointer-events: ", ";\n\n  &:hover {\n    background-color: ", ";\n  }\n"])), function (_a) {
    var disabled = _a.disabled;
    return (disabled ? 0.4 : 1);
}, function (_a) {
    var disabled = _a.disabled;
    return (disabled ? "none" : "auto");
}, function (props) { return getColor("borderSecondary")(props); });
var DropdownItem = function (_a) {
    var _b = _a.item, value = _b.value, label = _b.label, icon = _b.icon, reverse = _b.reverse, disabled = _b.disabled, onClick = _b.onClick, restItem = __rest(_b, ["value", "label", "icon", "reverse", "disabled", "onClick"]), selectedValue = _a.value, onItemClick = _a.onItemClick, rest = __rest(_a, ["item", "value", "onItemClick"]);
    var selected = selectedValue === value;
    var onSelect = function (event) {
        if (onClick)
            onClick(event);
        onItemClick(value);
    };
    return (React.createElement(ItemContainer, __assign({ "aria-selected": selected, disabled: disabled || selected, onClick: onSelect }, restItem, rest),
        reverse && React.createElement(Text, null, label),
        icon,
        !reverse && React.createElement(Text, null, label)));
};
export default DropdownItem;
var templateObject_1;
